import url from "./_URL";
import axios from "axios";

export default parametros => {
  const http = axios.post(url.api, parametros);
  return http;
};


